import React, { useState, useEffect, useRef } from 'react';
import './header.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import api from '../../api/api';
import * as newApi from '../../api/apiCollection';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
// Removed Dropdown import from react-bootstrap
import { Menu, Modal } from 'antd';
import "../location/location.css";
import { DownOutlined } from '@ant-design/icons';
import { Dropdown as AntdDropdown, Space } from 'antd';
import { BsCart3, BsSun, BsMoon } from 'react-icons/bs';
import { HiOutlineUser, HiOutlineLogin } from 'react-icons/hi';
import { RiUser3Line } from 'react-icons/ri';

// reducers import
import { setCity } from "../../model/reducer/locationReducer";
import { setPaymentSetting } from '../../model/reducer/settingReducer';
import { setLanguage, setLanguageList } from "../../model/reducer/languageReducer";
import { setFilterSearch, setFilterCategory, setProductBySearch, setFilterBrands, setFilterSection, clearAllFilter } from "../../model/reducer/productFilterReducer";
import { setCSSMode } from '../../model/reducer/cssmodeReducer';
import { setCart, setCartProducts, setCartSubTotal, setIsGuest, setTotalCartValue } from '../../model/reducer/cartReducer';

import googleplayimg from '../../utils/googleplay.png'
import appstoreimg from '../../utils/appstore.png'
import facebook from '../../utils/social_img/facebook.png'
import instagram from '../../utils/social_img/instagram.png'
import snapchat from '../../utils/social_img/snapchat.png'
import tiktok from '../../utils/social_img/tik-tok.png'
import twitter from '../../utils/social_img/twitter.png'
import whatsapp from '../../utils/social_img/whatsapp.png'

// components imports
import Location from '../location/Location';
import Login from '../login/Login';
import Cart from '../cart/Cart';
import { logoutAuth } from '../../model/reducer/authReducer';
import { removelocalstorageOTP } from '../../utils/manageLocalStorage';
import { confirmAlert } from 'react-confirm-alert';

const Header = () => {
    const closeSidebarRef = useRef();
    const searchNavTrigger = useRef();
    const { t } = useTranslation();
    const curr_url = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const shop = useSelector(state => state.shop);
    const city = useSelector(state => (state.city));
    const cssmode = useSelector(state => (state.cssmode));
    const user = useSelector(state => (state.user));
    const cart = useSelector(state => (state.cart));
    const favorite = useSelector(state => (state.favourite));
    const setting = useSelector(state => (state.setting));
    const languages = useSelector((state) => (state.language));
    const category = shop && shop?.shop?.categories;
    const filter = useSelector(state => state.productFilter);

    const [isSticky, setIsSticky] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [bodyScroll, setBodyScroll] = useState(false);
    const [locModal, setLocModal] = useState(false);
    const [mobileNavActKey, setMobileNavActKey] = useState(null);
    const [isLocationPresent, setisLocationPresent] = useState(false);
    const [totalNotification, settotalNotification] = useState(null);
    const [isDesktopView, setIsDesktopView] = useState(window.innerWidth > 768);
    const [isCartSidebarOpen, setIsCartSidebarOpen] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    // Removed category dropdown states
    const [query, setQuery] = useState("")
    const [typingTimeout, setTypingTimeout] = useState(null);
    const [hoveredCategory, setHoveredCategory] = useState(null);
    const [hoverTimeout, setHoverTimeout] = useState(null);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [currentDropdownLevel, setCurrentDropdownLevel] = useState(null); // للتتبع المستوى الحالي
    const [dropdownHistory, setDropdownHistory] = useState([]); // لتتبع مسار التنقل

    const handleCategoryMouseEnter = (cat) => {
        if (hoverTimeout) {
            clearTimeout(hoverTimeout);
        }
        setHoveredCategory(cat);
        setCurrentDropdownLevel(cat);
        setDropdownHistory([]);
    };

    const handleCategoryMouseLeave = () => {
        const timeout = setTimeout(() => {
            setHoveredCategory(null);
            setCurrentDropdownLevel(null);
            setDropdownHistory([]);
        }, 800); // زيادة التأخير إلى 800ms للتفاعل الأفضل
        setHoverTimeout(timeout);
    };

    const handleDropdownMouseEnter = () => {
        if (hoverTimeout) {
            clearTimeout(hoverTimeout);
        }
    };

    const handleDropdownMouseLeave = () => {
        // إغلاق فوري عند مغادرة القائمة المنسدلة
        setHoveredCategory(null);
        setCurrentDropdownLevel(null);
        setDropdownHistory([]);
        if (hoverTimeout) {
            clearTimeout(hoverTimeout);
        }
    };

    const handleSubcategoryEnter = (subcategory) => {
        setDropdownHistory(prev => [...prev, currentDropdownLevel]);
        setCurrentDropdownLevel(subcategory);
    };

    const handleBackToParent = () => {
        if (dropdownHistory.length > 0) {
            const parent = dropdownHistory[dropdownHistory.length - 1];
            setCurrentDropdownLevel(parent);
            setDropdownHistory(prev => prev.slice(0, -1));
        }
    };

    const openCanvasModal = () => {
        handleModal();
        closeSidebarRef.current.click();
    };

    const handleLogout = () => {
        confirmAlert({
            title: t('logout_title'),
            message: t('logout_message'),
            buttons: [
                {
                    label: t("Ok"),
                    onClick: async () => {
                        await api.logout(user?.jwtToken).then(response => response.json())
                            .then(result => {
                                if (result.status === 1) {
                                    removelocalstorageOTP();
                                    dispatch(setFilterBrands({ data: [] }));
                                    dispatch(setFilterCategory({ data: null }));
                                    dispatch(setFilterSearch({ data: null }));
                                    dispatch(setFilterSection({ data: null }));
                                    dispatch(setCartProducts({ data: [] }));
                                    dispatch(setCartSubTotal({ data: 0 }));
                                    dispatch(logoutAuth({ data: null }));
                                    dispatch(setIsGuest({ data: true }));
                                    toast.success("تم تسجيل الخروج بنجاح");
                                    navigate('/');
                                }
                                else {
                                    toast.info(result.message);
                                }
                            });
                    }
                },
                {
                    label: t('Cancel'),
                    onClick: () => { }
                }
            ]
        });
    };

    const items = [
        {
            key: '1',
            label: (
                <span onClick={() => navigate("/profile")} className="dropdown-item-custom">
                    الملف الشخصي
                </span>
            ),
        },
        {
            key: '2',
            label: (
                <span onClick={() => navigate("/profile/orders")} className="dropdown-item-custom">
                    الطلبات
                </span>
            )
        },
        {
            key: '3',
            label: (
                <span onClick={() => navigate("/wishlist")} className="dropdown-item-custom">
                    المفضلة
                </span>
            )
        },
        {
            key: '4',
            label: (
                <span onClick={() => navigate("/notification")} className="dropdown-item-custom">
                    الإشعارات
                </span>
            )
        },
        {
            key: '5',
            label: (
                <span className="dropdown-item-custom" onClick={() => navigate("/profile/address")}>
                    العناوين
                </span>
            )
        },
        {
            key: '6',
            label: (
                <span className="dropdown-item-custom" onClick={() => navigate("/profile/wallet-transaction")}>
                    المحفظة
                </span>
            )
        },
        {
            key: '7',
            label: (
                <span onClick={() => navigate("/profile/transactions")} className="dropdown-item-custom">
                    المعاملات
                </span>
            )
        },
        {
            key: '8',
            label: (
                <span className="dropdown-item-custom" onClick={handleLogout}>
                    تسجيل الخروج
                </span>
            )
        },
    ];

    useEffect(() => {
        const fetchCartData = async () => {
            try {
                const result = await newApi.getCart({ latitude: city?.city?.latitude, longitude: city?.city?.longitude })
                if (result.status == 1) {
                    const productsData = result?.data?.cart?.map((product) => {
                        return {
                            product_id: product?.product_id,
                            product_variant_id: product?.product_variant_id,
                            qty: product?.qty
                        };
                    });
                    dispatch(setCartProducts({ data: productsData }));
                    dispatch(setCartSubTotal({ data: result?.data?.sub_total }))
                } else if (result.message == "No item(s) found in users cart") {
                    dispatch(setCartProducts({ data: [] }));
                }
            } catch (err) {
                console.log(err?.message);
            }
        };
        if (user?.jwtToken) {
            fetchCartData()
        }
    }, [user?.jwtToken])

    useEffect(() => {
        if (bodyScroll) {
            document.body.style.overflow = 'auto';
            document.body.style.height = '100vh';
        } else {
            document.body.style.overflow = 'auto';
            document.body.style.height = 'auto';
        }
    }, [bodyScroll]);

    const handleModal = () => {
        setLocModal(true);
        setBodyScroll(true);
    };

    useEffect(() => {
        if (curr_url.pathname != "/products") {
            dispatch(setFilterSearch({ data: null }));
        }
    }, [curr_url]);

    useEffect(() => {
        const fetchCity = async () => {
            try {
                if (setting.setting?.default_city && city.city == null) {
                    setisLocationPresent(true);
                    const latitude = parseFloat(setting.setting.default_city?.latitude)
                    const longitude = parseFloat(setting.setting.default_city?.longitude)
                    const response = await newApi.getCity({ latitude: latitude, longitude: longitude })
                    if (response.status === 1) {
                        dispatch(setCity({ data: response.data }));
                    } else {
                        setLocModal(true);
                    }
                    dispatch(setCity({ data: response.data }));
                }
                else if (setting?.setting && setting.setting?.default_city == null && city?.city == null) {
                    setLocModal(true);
                }
            } catch (error) {
                console.log("error", error)
            }
        }
        fetchCity()
    }, [setting]);

    useEffect(() => {
        api.getSystemLanguage(0, 0)
            .then((response) => response.json())
            .then((result) => {
                dispatch(setLanguageList({ data: result.data }));
            });
        
        if ((curr_url?.pathname == "/") || (curr_url?.pathname == "/profile/wallet-transaction") || (curr_url?.pathname == "/checkout")) {
            fetchPaymentSetting();
        }
        
        handleResize();
        window.addEventListener('resize', handleResize);

        const handleClickOutside = (event) => {
            if (closeSidebarRef.current && !closeSidebarRef.current.contains(event.target) && !event.target.closest(".lang-mode-utils")) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            window.removeEventListener('resize', handleResize);
            if (hoverTimeout) {
                clearTimeout(hoverTimeout);
            }
        };
    }, []);

    const fetchPaymentSetting = async () => {
        await api.getPaymentSettings(user?.jwtToken)
            .then(response => response.json())
            .then(result => {
                if (result.status === 1) {
                    dispatch(setPaymentSetting({ data: JSON.parse(atob(result.data)) }));
                }
            })
            .catch(error => console.log(error));
    };

    const handleChangeLanguage = (id) => {
        api.getSystemLanguage(id, 0)
            .then(response => response.json())
            .then(result => {
                if (result.status === 1) {
                    document.documentElement.dir = result.data.type;
                    dispatch(setLanguage({ data: result.data }));
                }
            });
    };

    const placeHolderImage = (e) => {
        e.target.src = setting.setting?.web_logo;
    };

    const handleResize = () => {
        setIsDesktopView(window.innerWidth > 768);
    };

    const handleMobileNavActKey = (key) => {
        setMobileNavActKey(key == mobileNavActKey ? null : key);
    };

    const handleThemeChange = (theme) => {
        document.body.setAttribute("data-bs-theme", theme);
        dispatch(setCSSMode({ data: theme }));
    };

    // Removed category dropdown handler

    const handleSearch = async (query) => {
        try {
            const response = await newApi.productByFilter({
                latitude: city?.city?.latitude,
                longitude: city?.city?.longitude,
                filters: { ...filter, search: query }
            });
            dispatch(setProductBySearch({ data: response?.data }));
        } catch (error) {
            console.log("error", error);
        }
    };

    // Removed category dropdown selector

    const selectCategory = (category) => {
        dispatch(clearAllFilter());
        dispatch(setFilterCategory({ data: category.id }));
        if (category?.has_child === true) {
            navigate(`/category/${category.slug}`, { state: { categoryName: category.name } });
        } else {
            navigate('/products');
        }
    };

    const handleQueryChange = (e) => {
        const value = e.target.value.trim();

        if (value === "") {
            dispatch(setFilterSearch({ data: "" }));
            clearTimeout(typingTimeout);
            dispatch(setProductBySearch({ data: [] }));
            return;
        }

        setQuery(value);
        dispatch(setFilterSearch({ data: value }));

        if (typingTimeout) {
            clearTimeout(typingTimeout);
        }

        const timeout = setTimeout(() => {
            handleSearch(value);
        }, 300);

        setTypingTimeout(timeout);
    };

    const renderCurrentLevelCategories = (categories) => {
        if (!categories || categories.length === 0) return null;
        
        return categories.map((cat, index) => (
            <li key={cat.id} className="dropdown-category-item">
                <div className="dropdown-category-content">
                    <div 
                        className="dropdown-category-info" 
                        onClick={() => selectCategory(cat)}
                        onMouseEnter={() => {
                            if (hoverTimeout) {
                                clearTimeout(hoverTimeout);
                            }
                        }}
                        onMouseLeave={(e) => {
                            e.stopPropagation();
                            // لا نغلق القائمة عند مغادرة العنصر الفرعي فقط
                        }}
                    >
                        <span className="dropdown-category-name">{cat.name}</span>
                        {cat.has_child && cat.cat_active_childs && cat.cat_active_childs.length > 0 && (
                            <span className="dropdown-category-subtitle">
                                {cat.cat_active_childs.length} فئة فرعية
                            </span>
                        )}
                    </div>
                    {cat.has_child && cat.cat_active_childs && cat.cat_active_childs.length > 0 && (
                        <button 
                            className="dropdown-category-arrow"
                            onClick={(e) => {
                                e.stopPropagation();
                                handleSubcategoryEnter(cat);
                            }}
                            onMouseEnter={(e) => {
                                e.stopPropagation();
                                if (hoverTimeout) {
                                    clearTimeout(hoverTimeout);
                                }
                            }}
                            onMouseLeave={(e) => {
                                e.stopPropagation();
                                // لا نغلق القائمة عند مغادرة السهم فقط
                            }}
                        >
                            ←
                        </button>
                    )}
                </div>
            </li>
        ));
    };

    return (
        <>
            {/* Mobile Sidebar */}
            <div className="mobile-sidebar-overlay" style={{ display: isMobileMenuOpen ? 'block' : 'none' }} onClick={() => setIsMobileMenuOpen(false)}>
                <div className="mobile-sidebar" onClick={(e) => e.stopPropagation()}>
                    <div className="mobile-sidebar-header">
                        <img src={setting.setting && setting.setting.web_settings.web_logo} alt="البيت الشامل" className="mobile-sidebar-logo" />
                        <button className="mobile-sidebar-close" onClick={() => setIsMobileMenuOpen(false)}>
                            إغلاق
                        </button>
                    </div>
                    <div className="mobile-sidebar-content">
                        <nav className="mobile-sidebar-nav">
                            <ul>
                                <li><button onClick={() => { navigate('/'); setIsMobileMenuOpen(false); }}>الرئيسية</button></li>
                                <li><button onClick={() => { navigate('/products'); setIsMobileMenuOpen(false); }}>جميع المنتجات</button></li>
                                <li><button onClick={() => { navigate('/about'); setIsMobileMenuOpen(false); }}>من نحن</button></li>
                                <li><button onClick={() => { navigate('/contact'); setIsMobileMenuOpen(false); }}>تواصل معنا</button></li>
                                <li><button onClick={() => { navigate('/faq'); setIsMobileMenuOpen(false); }}>الأسئلة الشائعة</button></li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>

            {/* Header */}
            <header className="modern-header">
                {/* Top Bar */}
                <div className="header-top-bar">
                    <div className="container">
                        <div className="top-bar-content">
                            <div className="top-bar-left">
                                <div className="social-links">
                                    {setting?.setting && setting?.setting?.social_media?.map((icon, index) => (
                                        <a key={index} href={icon.link} className="social-link">
                                            {icon.icon === 'fab fa-qq' ? (
                                                <img src={snapchat} alt='Snapchat' className="social-icon" />
                                            ) : (
                                                <i className={`fab ${icon.icon}`}></i>
                                            )}
                                        </a>
                                    ))}
                                </div>
                            </div>
                            <div className="top-bar-center">
                                <h3 className="welcome-text">مرحبا بكم في البيت الشامل</h3>
                            </div>
                            <div className="top-bar-right">
                                                            <div className="header-actions">
                                <button 
                                    className="cart-button"
                                    onClick={() => setIsCartSidebarOpen(true)}
                                    title="السلة"
                                >
                                    <BsCart3 size={18} />
                                    {(cart.isGuest ? cart?.guestCart?.length : cart?.cartProducts?.length) > 0 && (
                                        <span className="cart-count">
                                            {cart.isGuest ? cart?.guestCart?.length : cart?.cartProducts?.length}
                                        </span>
                                    )}
                                </button>
                                
                                <div className="user-section">
                                    {user?.jwtToken === "" ? (
                                        <button 
                                            className="login-button"
                                            onClick={() => setShowModal(true)}
                                            title="تسجيل الدخول"
                                        >
                                            <HiOutlineLogin size={18} />
                                        </button>
                                    ) : (
                                        <AntdDropdown menu={{ items }}>
                                            <button className="user-button" title="حسابي">
                                                <RiUser3Line size={18} />
                                                <DownOutlined size={12} />
                                            </button>
                                        </AntdDropdown>
                                    )}
                                </div>
                                
                                <button 
                                    className="theme-toggle"
                                    onClick={() => handleThemeChange(cssmode?.cssmode === "dark" ? "light" : "dark")}
                                    title={cssmode?.cssmode === "dark" ? "الوضع الفاتح" : "الوضع المظلم"}
                                >
                                    {cssmode?.cssmode === "dark" ? <BsSun size={18} /> : <BsMoon size={18} />}
                                </button>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>

                                {/* Search Bar */}
                <div className="header-search-bar">
                    <div className="container">
                        <div className="search-bar-content">
                            <div className="search-section">
                                <div className="search-wrapper">
                                    <input 
                                        type="text" 
                                        className="search-input"
                                        placeholder="ابحث عن المنتجات..."
                                        value={filter?.search || ""}
                                        onChange={handleQueryChange}
                                    />
                                    
                                    <button 
                                        className="search-button"
                                        onClick={() => {
                                            dispatch(setProductBySearch({ data: "" }));
                                            navigate("/products");
                                        }}
                                    >
                                        بحث
                                    </button>
                                </div>

                                {(filter?.search_product?.length > 0 && curr_url.pathname !== '/products' && query?.length >= 1) && (
                                    <div className="search-results">
                                        {filter?.search_product?.map((product) => (
                                            <Link 
                                                key={product.id}
                                                to={`/product/${product?.slug}`} 
                                                className="search-result-item"
                                                onClick={() => {
                                                    setQuery("");
                                                    dispatch(setProductBySearch({ data: "" }));
                                                }}
                                            >
                                                {product?.name}
                                            </Link>
                                        ))}
                                    </div>
                                )}
                            </div>
                            
                            <div className="app-links-section">
                                <div className="app-promotion">
                                    <div className="app-promotion-content">
                                        <h4 className="app-promotion-title">تسوق بواسطة تطبيق البيت الشامل</h4>
                                        <p className="app-promotion-subtitle">تجربة تسوق أسرع وأسهل - مع عروض حصرية</p>
                                    </div>
                                    <div className="app-download-buttons">
                                <Link to='https://play.google.com/store/apps/details?id=com.albaitalshamel.holol' className="app-link" target="_blank">
                                            <img src={googleplayimg} alt="تحميل من جوجل بلاي" />
                                </Link>
                                <Link to='https://apps.apple.com/us/app/%D8%A7%D9%84%D8%A8%D9%8A%D8%AA-%D8%A7%D9%84%D8%B4%D8%A7%D9%85%D9%84/id6742510249' className="app-link" target="_blank">
                                            <img src={appstoreimg} alt="تحميل من آب ستور" />
                                </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main Header */}
                <div className="header-main">
                    <div className="container">
                        <div className="header-main-content">
                            <div className="header-left">
                                <button 
                                    className="mobile-menu-toggle"
                                    onClick={() => setIsMobileMenuOpen(true)}
                                    aria-label="فتح القائمة"
                                    title="فتح القائمة"
                                    type="button"
                                    role="button"
                                >
                                    <i className="fas fa-bars" aria-hidden="true"></i>
                                </button>
                                <Link to="/" className="logo">
                                    <img src={setting.setting && setting.setting.web_settings.web_logo} alt="البيت الشامل" />
                                </Link>
                            </div>

                            <div className="header-center">
                                <nav className="main-navigation">
                                    <ul className="nav-list">
                                        <li className={`nav-item ${curr_url.pathname === "/" ? "active" : ""}`}>
                                            <button onClick={() => navigate('/')}>الرئيسية</button>
                                        </li>
                                        <li className={`nav-item ${curr_url.pathname === "/products" ? "active" : ""}`}>
                                            <button onClick={() => navigate('/products')}>جميع المنتجات</button>
                                        </li>
                                        <li className={`nav-item ${curr_url.pathname === "/category/all" ? "active" : ""}`}>
                                            <button onClick={() => navigate('/category/all')}>التصنيفات</button>
                                        </li>
                                        {category?.map((cat) => (
                                            <li key={cat.id} className="nav-item category-item">
                                                <button
                                                    onClick={() => selectCategory(cat)}
                                                    onMouseEnter={() => handleCategoryMouseEnter(cat)}
                                                    onMouseLeave={handleCategoryMouseLeave}
                                                    style={{ position: 'relative' }}
                                                >
                                                    {cat.name}
                                                    {cat.has_child && cat.cat_active_childs && cat.cat_active_childs.length > 0 && (
                                                        <span className="category-arrow">⌄</span>
                                                    )}
                                                </button>
                                                                                                {hoveredCategory?.id === cat.id && cat.has_child && cat.cat_active_childs && cat.cat_active_childs.length > 0 && (
                                                    <div 
                                                        className="category-dropdown show"
                                                        onMouseEnter={handleDropdownMouseEnter}
                                                        onMouseLeave={handleDropdownMouseLeave}
                                                        style={{ pointerEvents: 'auto' }}
                                                    >
                                                        <div className="category-dropdown-header">
                                                            {dropdownHistory.length > 0 && (
                                                                <button 
                                                                    className="category-dropdown-back"
                                                                    onClick={handleBackToParent}
                                                                    onMouseEnter={() => {
                                                                        if (hoverTimeout) {
                                                                            clearTimeout(hoverTimeout);
                                                                        }
                                                                    }}
                                                                >
                                                                    → رجوع
                                                                </button>
                                                            )}
                                                            <h3 className="category-dropdown-title">
                                                                {currentDropdownLevel?.name || cat.name}
                                                            </h3>
                                                            <button 
                                                                className="category-dropdown-close"
                                                                onClick={() => {
                                                                    setHoveredCategory(null);
                                                                    setCurrentDropdownLevel(null);
                                                                    setDropdownHistory([]);
                                                                }}
                                                                onMouseEnter={() => {
                                                                    if (hoverTimeout) {
                                                                        clearTimeout(hoverTimeout);
                                                                    }
                                                                }}
                                                            >
                                                                ✕
                                                            </button>
                                                        </div>
                                                        <ul className="category-dropdown-list">
                                                            {renderCurrentLevelCategories(
                                                                currentDropdownLevel?.cat_active_childs || cat.cat_active_childs
                                                            )}
                                                        </ul>
                                                    </div>
                                                    )}
                                            </li>
                                        ))}
                                    </ul>
                                </nav>
                            </div>

                          
                        </div>
                    </div>
                </div>

                {/* Mobile Bottom Navigation */}
                <div className="mobile-bottom-nav">
                    <div className="mobile-bottom-nav-content">
                        <button 
                            className={`mobile-bottom-nav-item ${curr_url.pathname === '/' ? 'active' : ''}`} 
                            onClick={() => navigate('/')}
                        >
                            <div className="nav-icon">
                                <i className="fas fa-home"></i>
                            </div>
                            <span className="nav-label">الرئيسية</span>
                        </button>
                        
                        <button 
                            className={`mobile-bottom-nav-item ${curr_url.pathname === '/products' ? 'active' : ''}`} 
                            onClick={() => navigate('/products')}
                        >
                            <div className="nav-icon">
                                <i className="fas fa-th-large"></i>
                            </div>
                            <span className="nav-label">المتجر</span>
                        </button>
                        
                        <button 
                            className={`mobile-bottom-nav-item ${mobileNavActKey === 2 ? 'active' : ''}`} 
                            onClick={() => handleMobileNavActKey(2)}
                        >
                            <div className="nav-icon">
                                <i className="fas fa-search"></i>
                            </div>
                            <span className="nav-label">البحث</span>
                            </button>
                        
                        <button 
                            className={`mobile-bottom-nav-item ${mobileNavActKey === 4 ? 'active' : ''}`} 
                            onClick={() => {
                            if (user?.jwtToken === "") {
                                toast.error(t("required_login_message_for_wishlist"));
                            } else if (city.city === null) {
                                toast.error("الرجاء اختيار موقع التوصيل أولاً!");
                            } else {
                                navigate("/wishlist");
                            }
                            }}
                        >
                            <div className="nav-icon">
                                <i className="fas fa-heart"></i>
                            </div>
                            <span className="nav-label">المفضلة</span>
                        </button>
                        
                        <button 
                            className={`mobile-bottom-nav-item ${mobileNavActKey === 5 ? 'active' : ''}`} 
                            onClick={() => {
                            if (user?.jwtToken === "") {
                                setShowModal(true);
                            } else {
                                navigate("/profile");
                            }
                            }}
                        >
                            <div className="nav-icon">
                                <i className="fas fa-user"></i>
                            </div>
                            <span className="nav-label">الحساب</span>
                        </button>
                    </div>
                </div>

                {/* Mobile Search & App Download */}
                <div className={`mobile-search-panel ${mobileNavActKey === 2 ? 'active' : ''}`}>
                    <div className="mobile-search-header">
                        <h3 className="search-panel-title">البحث وتحميل التطبيق</h3>
                        <button 
                            className="close-search-panel"
                            onClick={() => setMobileNavActKey(null)}
                        >
                            <i className="fas fa-times"></i>
                        </button>
                    </div>
                    
                    <div className="mobile-search-content">
                        <div className="search-section-mobile">
                            <div className="search-input-wrapper">
                                <i className="fas fa-search search-icon"></i>
                        <input 
                            type="text" 
                                    className="mobile-search-input"
                            placeholder="ابحث عن المنتجات..."
                            value={filter?.search || ""}
                            onChange={handleQueryChange}
                        />
                                <button 
                                    className="search-btn-mobile"
                                    onClick={() => {
                            dispatch(setProductBySearch({ data: "" }));
                            navigate("/products");
                                        setMobileNavActKey(null);
                                    }}
                                >
                            بحث
                        </button>
                    </div>
                            
                    {filter?.search_product?.length > 0 && (
                        <div className="mobile-search-results">
                            {filter?.search_product?.map((product) => (
                                <Link 
                                    key={product.id}
                                    to={`/product/${product?.slug}`} 
                                            className="search-result-mobile"
                                    onClick={() => {
                                        setQuery("");
                                        dispatch(setProductBySearch({ data: "" }));
                                        setMobileNavActKey(null);
                                    }}
                                >
                                            <i className="fas fa-tag"></i>
                                    {product?.name}
                                </Link>
                            ))}
                        </div>
                    )}
                        </div>
                        
                        <div className="mobile-app-download">
                            <div className="app-download-header">
                                <i className="fas fa-mobile-alt app-icon"></i>
                                <div className="app-download-text">
                                    <h4>تحميل تطبيق البيت الشامل</h4>
                                    <p>تجربة تسوق أسرع وأسهل مع عروض حصرية</p>
                                </div>
                            </div>
                            
                            <div className="mobile-app-buttons">
                                <Link 
                                    to='https://play.google.com/store/apps/details?id=com.albaitalshamel.holol' 
                                    className="mobile-app-link google-play" 
                                    target="_blank"
                                >
                                    <img src={googleplayimg} alt="تحميل من جوجل بلاي" />
                                    <div className="app-link-text">
                                        <span className="store-name">Google Play</span>
                                        <span className="download-text">احصل عليه من</span>
                                    </div>
                                </Link>
                                
                                <Link 
                                    to='https://apps.apple.com/us/app/%D8%A7%D9%84%D8%A8%D9%8A%D8%AA-%D8%A7%D9%84%D8%B4%D8%A7%D9%85%D9%84/id6742510249' 
                                    className="mobile-app-link app-store" 
                                    target="_blank"
                                >
                                    <img src={appstoreimg} alt="تحميل من آب ستور" />
                                    <div className="app-link-text">
                                        <span className="store-name">App Store</span>
                                        <span className="download-text">تحميل من</span>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            {/* Modals */}
            <Login show={showModal} setShow={setShowModal} />
            <Modal className="location" centered open={locModal} transitionName="">
                <Location 
                    isLocationPresent={isLocationPresent} 
                    setisLocationPresent={setisLocationPresent}
                    showModal={locModal} 
                    setLocModal={setLocModal} 
                    bodyScroll={setBodyScroll} 
                />
            </Modal>
            <Cart isCartSidebarOpen={isCartSidebarOpen} setIsCartSidebarOpen={setIsCartSidebarOpen} />
        </>
    );
};

export default Header;
